import { render, staticRenderFns } from "./UploadPicComs.vue?vue&type=template&id=2cd82c37&"
import script from "./UploadPicComs.vue?vue&type=script&lang=ts&"
export * from "./UploadPicComs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports